export const SPRITE_IDS = [
  "tile_00",
  "tile_00_b",
  "tile_01",
  "tile_01_b",
  "tile_02",
  "tile_02_b",
  "tile_03",
  "tile_03_b",
  "tile_04",
  "tile_04_b",
  "tile_05",
  "tile_05_b",
  "tile_06",
  "tile_06_b",
  "tile_07",
  "tile_07_b",
  "tile_08",
  "tile_08_b",
  "tile_09",
  "tile_09_b",
  "tile_10",
  "tile_10_b",
  "tile_11",
  "tile_11_b",
  "bomb_3",
  "bomb_3_b",
  "bomb_4",
  "bomb_4_b",
  "bomb_5",
  "bomb_5_b",
  "wipe",
  "wipe_b",
  "crate",
  "crate_b",
  "lock",
  "lock_b",
  "steel",
  "steel_b",
  "fx_pop",
  "fx_pop_1",
  "fx_pop_2",
  "fx_pop_3",
  "fx_pop_4",
  "fx_explosion",
  "fx_explosion_1",
  "fx_explosion_2",
  "fx_explosion_3",
  "fx_explosion_4",
  "fx_explosion_5",
  "fx_explosion_6",
  "fx_explosion_7",
  "fx_explosion_8",
  "fx_wipewave",
  "fx_wipewave_1",
  "fx_wipewave_2",
  "fx_wipewave_3",
  "fx_wipewave_4",
  "fx_rotateflash",
  "fx_rotateflash_1",
  "fx_rotateflash_2",
  "fx_rotateflash_3",
  "fx_rotateflash_4",
  "ui_life",
  "ui_key",
  "ui_groove",
  "ui_groove_01",
  "ui_groove_02",
  "ui_groove_03",
  "ui_groove_04",
  "ui_groove_05",
  "ui_groove_06",
  "ui_groove_07",
  "ui_groove_08",
  "ui_groove_09",
  "ui_groove_10",
  "ui_groove_11",
  "ui_groove_12",
  "ui_groove_13",
  "ui_groove_14",
  "ui_groove_15",
  "ui_groove_16",
  "ui_timer",
  "ui_timer_1",
  "ui_timer_2",
  "ui_timer_3",
  "ui_timer_4",
  "ui_music_on",
  "ui_music_off"
] as const;

export type SpriteId = (typeof SPRITE_IDS)[number];

export const REQUIRED_SPRITE_IDS: readonly SpriteId[] = SPRITE_IDS;

export interface AtlasFrame {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface AtlasManifest {
  imagePath: string;
  frames: Record<string, AtlasFrame>;
  cacheKey?: string;
}

export interface AssetLoadState {
  ready: boolean;
  usingFallback: boolean;
  missingRequiredFrameIds: string[];
  reason?: string;
  atlasImageUrl?: string;
}
